<div class="row-height container" fxLayout="column" fxLayoutAlign="center center">
    <mat-card>
        <div fxLayout="row" fxLayoutAlign="center center">
            <p class="mat-headline">C Logo</p>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center">
            <p class="mat-title text-center">Hello,<span> {{this.feedbackName}}</span></p>
            <p class="mat-display-2 text-center">Thank you for Feedback!!</p>
            <a (click)="gotohome()" class="color-accent text-center"> Go to Home Page</a>
        </div>
    </mat-card>
</div>